import { getDefaultMaxCapsuleDuration } from '@/services/systemConfiguration.utilities';
import { TREND_TOOLS } from '@/toolSelection/investigate.constants';
import { getToolConfigParams } from '@/tools/tool.utilities';
import type { DisplayToolState } from '@/tools/display/displayTool.store';
import type { DurationWithUnits, ToolConfigParams, ToolConfigValue } from '@/tools/tool.types';

export const displayToolFormulaBuilder = {
  var(varName: string, suffix?: string): string {
    return `$${varName}${suffix || ''}`;
  },

  operator(operator: string, args: string[]): string {
    return `${operator}(${args.join(', ')})`;
  },

  duration(duration: { value: string | number; units: string }): string {
    return `${duration.value}${duration.units}`;
  },
};

export function getDisplayToolMaximumDuration(
  maximumDuration: DurationWithUnits | null | undefined,
): DurationWithUnits | undefined {
  return maximumDuration ?? (getDefaultMaxCapsuleDuration() as DurationWithUnits | undefined);
}

export function getDisplayToolConfigParams(state: DisplayToolState): ToolConfigParams {
  return getToolConfigParams({
    serializedState: state as unknown as Record<string, ToolConfigValue>,
    toolType: TREND_TOOLS.DISPLAY,
    parameterDefinitionKeys: [],
    advancedParametersCollapsed: state.advancedParametersCollapsed,
  });
}
